import MediaDenied from './MediaDenied'
export default MediaDenied
